import { Schema } from "./Schema.js";
/** Schema that passes through to a source schema. */
export class ThroughSchema extends Schema {
    source;
    constructor({ source, ...options }) {
        super({ ...source, ...options });
        this.source = source;
    }
    validate(unsafeValue) {
        return this.source.validate(unsafeValue);
    }
}
